var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_SUBMIT,
                          expression: "RMC_PROD_FARM_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detailForm,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("农场清单")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Name",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.category3Name,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "category3Name",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.category3Name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sponsor",
                                  prop: "sponsorName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sponsorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "sponsorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.sponsorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "Farm Group",
                                  prop: "farmGroup",
                                  rules: _vm.rules.farmGroup,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.farmGroup,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "farmGroup",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.farmGroup",
                                    },
                                  },
                                  _vm._l(
                                    _vm.farmGroupOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: { label: item, value: item },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: { label: "农场", prop: "farmName" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.farmName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "farmName", $$v)
                                    },
                                    expression: "detailForm.farmName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "审核类型", prop: "party" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.partyChange },
                                    model: {
                                      value: _vm.detailForm.party,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "party", $$v)
                                      },
                                      expression: "detailForm.party",
                                    },
                                  },
                                  _vm._l(
                                    _vm.partyOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "2方验证审核结果",
                                      prop: "partyAuditResult2",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.detailForm.partyAuditResult2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditResult2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditResult2",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "2方验证审核时间",
                                      prop: "partyAuditDate2",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.detailForm.partyAuditDate2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditDate2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditDate2",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            !_vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "3方验证审核时间",
                                      prop: "partyAuditDate3",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.detailForm.partyAuditDate3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "partyAuditDate3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "detailForm.partyAuditDate3",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            !_vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "MGG审核结果",
                                      prop: "mggAuditResult",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.detailForm.mggAuditResult,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.detailForm,
                                            "mggAuditResult",
                                            $$v
                                          )
                                        },
                                        expression: "detailForm.mggAuditResult",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            !_vm.isShow
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "GGAP审核结果",
                                      prop: "ggapAuditResult",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.detailForm.ggapAuditResult,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.detailForm,
                                              "ggapAuditResult",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "detailForm.ggapAuditResult",
                                        },
                                      },
                                      _vm._l(
                                        _vm.ggapAuditResultOptions,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.isShow
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "GNN", prop: "gnn" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.detailForm.gnn,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.detailForm, "gnn", $$v)
                                        },
                                        expression: "detailForm.gnn",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("验证审核报告")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c("el-row", { staticStyle: { "margin-bottom": "5px" } }, [
                      _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.RMC_PROD_FARM_UPLOAD,
                                  expression: "RMC_PROD_FARM_UPLOAD",
                                },
                              ],
                            },
                            [
                              _vm.detailForm.party === 20
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.openFile1 },
                                    },
                                    [_vm._v("上传")]
                                  )
                                : _vm._e(),
                              _vm.detailForm.party === 30
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.openFile2 },
                                    },
                                    [_vm._v("上传")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c(
                      "el-table",
                      {
                        ref: "plxTable",
                        attrs: {
                          data: _vm.tableData,
                          "max-height": "500",
                          border: "",
                          "highlight-current-row": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "操作",
                            width: "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.ms_userId === scope.row.createBy
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDel(
                                                scope.row.tmDocumentId,
                                                scope.$index,
                                                _vm.tableData,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "文件类型",
                            prop: "reportType",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "文件名称",
                            prop: "documentName",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDownload(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.documentName))]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "文件描述",
                            "show-overflow-tooltip": "",
                            prop: "docComments",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "上传人",
                            prop: "userName",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "上传时间",
                            prop: "createDate",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "附件上传",
            visible: _vm.dialogVisible1,
            width: "30%",
            "before-close": _vm.handleClose1,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible1 = $event
            },
          },
        },
        [
          _vm.dialogVisible1
            ? _c("uploadFile1", {
                attrs: { seq: _vm.seq, bizId: _vm.bizId, recType: _vm.recType },
                on: { close: _vm.handleClose1 },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "附件上传",
            visible: _vm.dialogVisible2,
            width: "30%",
            "before-close": _vm.handleClose2,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible2 = $event
            },
          },
        },
        [
          _vm.dialogVisible2
            ? _c("uploadFile2", {
                attrs: { seq: _vm.seq, bizId: _vm.bizId, recType: _vm.recType },
                on: { close: _vm.handleClose2 },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }